import { TOKEN_TYPE } from 'providers/constants/tokenNames';

import { cookies } from 'utils/cookies';

// список названий токенов с приоритетом
const tokenNamesPriorityList = [TOKEN_TYPE.MANAGER, TOKEN_TYPE.CLIENT, TOKEN_TYPE.EXTERNAL];

/** Получить токены из адресной строки и cookie */
function getTokensFromSearchParamsAndCookies() {
    const searchParams = new URLSearchParams(window.location.search);

    return tokenNamesPriorityList.map(tokenName => {
        return {
            name: tokenName,
            valueFromCookie: cookies.get(tokenName),
            valueFromURL: searchParams.get(tokenName),
        };
    });
}

/** Получить информацию токена */
export function getTokenMap() {
    const list = getTokensFromSearchParamsAndCookies();

    const withURLData = list.find(i => !!i.valueFromURL);

    if (withURLData) return { token: withURLData.valueFromURL!, tokenName: withURLData.name };

    const withCookieData = list.find(i => !!i.valueFromCookie);

    if (withCookieData) return { token: withCookieData.valueFromCookie!, tokenName: withCookieData.name };

    return null;
}
